// src/utils/getUserRole.js

const getUserRole = () => {
  try {
    let token =
      localStorage.getItem("jwtToken") ||
      localStorage.getItem("authToken") ||
      sessionStorage.getItem("token");

    if (!token) return null;

    // Caso venha como "Bearer xxxxxx.yyyyy.zzzz"
    if (token.startsWith("Bearer ")) {
      token = token.slice(7);
    }

    const parts = token.split(".");
    if (parts.length < 2) return null;

    let base64Url = parts[1];

    // Base64URL -> Base64
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    // Ajustar padding para múltiplo de 4
    const padding = 4 - (base64.length % 4);
    if (padding !== 4) {
      base64 += "=".repeat(padding);
    }

    const jsonPayload = atob(base64);
    const payload = JSON.parse(jsonPayload);

    return payload.role || null;
  } catch (error) {
    console.error("Erro ao decodificar token JWT:", error);
    return null;
  }
};

export default getUserRole;

// src/utils/getReadonlyFlag.js
export const getReadonlyFlag = () => {
  try {
    const token =
      localStorage.getItem("jwtToken") ||
      localStorage.getItem("authToken") ||
      sessionStorage.getItem("token");

    if (!token) return null;

    const cleanToken = token.startsWith("Bearer ") ? token.slice(7) : token;
    const base64Url = cleanToken.split(".")[1];
    if (!base64Url) return null;

    const base64 = base64Url
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(Math.ceil(base64Url.length / 4) * 4, "=");

    const jsonPayload = atob(base64);
    const payload = JSON.parse(jsonPayload);

    return typeof payload.readonly === "boolean" ? payload.readonly : null;
  } catch (error) {
    console.error("Erro ao decodificar token JWT:", error);
    return null;
  }
};

// A permissão de escrita no portal é definida exclusivamente pelo claim
// `readonly` emitido pelo backend. A ausência do claim mantém compatibilidade
// com tokens antigos, que continuam com acesso de escrita até serem renovados.
export const canEditClientContent = () => getReadonlyFlag() !== true;

